//白名单
<template>
  <div class="communicationRecord">
    <div class="queryArea clearfix">
      <div class="query_row">
        <div class="scan_box">
          <span class="sp_scan">平台：</span>
          <el-input
            v-model="queryFormData.platform"
            size="mini"
            class="ip_scan"
            @input="searchBtn"
            clearable
          >
          </el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan">状态：</span>
          <el-select
            v-model="queryFormData.is_white"
            size="mini"
            class="ip_scan"
            @change="searchBtn"
          >
            <el-option label="未授权" value="0"></el-option>
            <el-option label="生效中" value="1"></el-option>
          </el-select>
        </div>

        <div class="btn_box">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-refresh"
            @click="resetSearch"
            >重置筛选</el-button
          >
          <div class="import_area">
            <input
              class="import_file"
              ref="referenceUpload"
              type="file"
              @change="bmdImport"
            />
            <el-button size="mini" class="" icon="el-icon-upload2"
              >白名单导入</el-button
            >
          </div>

          <el-button
            size="mini"
            @click="templateDownload"
            icon="el-icon-download"
            >模板</el-button
          >
        </div>
      </div>
    </div>

    <!-- 内容 -->
    <div class="content">
      <tablePageComp
        :columnsList="columnsList"
        :dataList="dataList"
        :orderNumConfig="{}"
        :getDataConfig="dataQueryFunc()"
        :updateDataSignObj="{ updateDataTag, resetPageNum }"
        :totalCount="totalCount"
        :tableHeight="500"
      >
        <el-table-column slot="state" label="状态" align="center" width="80">
          <template slot-scope="{ row }">
            <span v-if="row.is_white == 1" class="fontColor_success"
              >生效中</span
            >
            <span v-else-if="row.is_white == 0" class="fontColor_danger"
              >未授权</span
            >
          </template>
        </el-table-column>
        <el-table-column
          slot="shop_url"
          label="店铺链接"
          align="center"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-link
              v-if="row.shop_url"
              :href="row.shop_url"
              target="_blank"
              class="fontColor_theme"
            >
              查看
            </el-link>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column
          slot="business_address"
          label="经营地址"
          align="center"
          width="150"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="{ row }">
            <el-input
              v-if="row.editable"
              v-model="formData.business_address"
              size="mini"
            ></el-input>
            <span v-else>{{ row.business_address }}</span>
          </template>
        </el-table-column>
        <el-table-column
          slot="person"
          label="负责人"
          align="center"
          width="150"
        >
          <template slot-scope="{ row }">
            <el-input
              v-if="row.editable"
              v-model="formData.person"
              size="mini"
            ></el-input>
            <span v-else>{{ row.person }}</span>
          </template>
        </el-table-column>
        <el-table-column
          slot="person_phone"
          label="联系电话"
          align="center"
          width="150"
        >
          <template slot-scope="{ row }">
            <el-input
              v-if="row.editable"
              v-model="formData.person_phone"
              size="mini"
            ></el-input>
            <span v-else>{{ row.person_phone }}</span>
          </template>
        </el-table-column>
        <el-table-column slot="handle" label="编辑" align="center" width="150">
          <template slot-scope="{ row }">
            <div v-if="row.editable">
              <el-button size="mini" type="success" @click="subEditHandle"
                >保存</el-button
              >
              <el-button size="mini" @click="row.editable = false"
                >取消</el-button
              >
            </div>
            <el-button
              v-else
              type="text"
              size="mini"
              @click="editHandle(row)"
              icon="el-icon-edit"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </tablePageComp>
    </div>
  </div>
</template>

<script>
import utils from "@/libs/utils";
import api from "@/api";
export default {
  name: "whiteList",
  props: ["contractProp"],
  data() {
    return {
      queryFormData: {
        platform: "",
        is_white: "1",
      },

      columnsList: [
        { slotName: "state" },
        {
          label: "平台",
          prop: "platform",
          width: 100,
        },
        // {
        //   label: "品牌名",
        //   prop: "brand_name",
        // },
        {
          label: "店铺名称",
          prop: "shop_name",
          width: 200,
        },
        {
          label: "掌柜昵称",
          prop: "shopkeeper_nick",
          width: 200,
        },
        {
          label: "店铺链接",
          slotName: "shop_url",
        },
        {
          label: "店长",
          prop: "shopowner_id",
          formatter: (row) => {
            return this.$tools.conversionName(row);
          },
          width: 100,
        },
        {
          label: "组长",
          prop: "leader_id",
          formatter: (row) => {
            return this.$tools.conversionName(row);
          },
          width: 100,
        },
        {
          label: "经营地址",
          slotName: "business_address",
        },
        {
          label: "负责人",
          slotName: "person",
        },
        {
          label: "联系电话",
          slotName: "person_phone",
        },
        {
          label: "创建时间",
          prop: "create_time",
          width: 150,
        },
        {
          label: "更新时间",
          prop: "update_time",
          width: 150,
        },
        {
          slotName: "handle",
        },
      ],
      dataList: [], //表格数据
      updateDataTag: false,
      resetPageNum: true,
      totalCount: 0, // 数据总条数

      formData: {
        business_address: "",
        person: "",
        person_phone: "",
      },
    };
  },

  methods: {
    editHandle(row) {
      this.dataList.forEach((item) => {
        if (item.id == row.id) {
          item.editable = true;
        } else {
          item.editable = false;
        }
      });
      this.formData = {
        id: row.id,
        business_address: row.business_address,
        person: row.person,
        person_phone: row.person_phone,
      };
    },
    subEditHandle() {
      this.$api
        .modifyCustomWhiteList(this.formData)
        .then((res) => {
          //   console.log(res);
          this.updateDataTag = !this.updateDataTag;
          this.resetPageNum = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 白名单导入
    bmdImport(e) {
      let file = e.target.files[0];
      let formData = new FormData(); //创建form对象
      formData.append("file", file); //通过append向form对象添加数据
      formData.append("industry", this.contractProp.category); // 行业
      formData.append("brand_name", this.contractProp.brand_name);
      formData.append("customer_file_id", this.contractProp.customer_file_id);
      formData.append("customer_id", this.contractProp.customer_id);
      formData.append("shopowner_id", this.$store.state.userId); // 店长
      let leader_id = this.$store.state.personInfo.filter(
        (item) => item.id == this.$store.state.userId
      )[0].leader_id;
      formData.append("leader_id", leader_id); // 组长-当前登录人上级，一般是运营来提交
      this.$refs.referenceUpload.value = null;
      // console.log(formData)

      const loading = this.$loading({
        lock: true,
        text: "导入中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      api
        .importWhiteListFunc(formData)
        .then(
          function(res) {
            // console.log(res)
            if (res.data.code == "0") {
              loading.close();
              utils.notificationInfo("提示", `${res.data.msg}`, "success");

              // 主动更新数据标记---更新，
              this.updateDataTag = !this.updateDataTag;
            } else {
              loading.close();
              utils.notificationInfo("错误提示", `${res.data.msg}`, "warning");
            }
          }.bind(this)
        )
        .catch((error) => {
          loading.close();
          utils.notificationInfo("错误提示", "导入失败", "error");
          console.log(error);
        });
    },
    // 白名单模板下载
    templateDownload() {
      window.location.href =
        "https://baibooa.oss-cn-hangzhou.aliyuncs.com/oa_xlsx/%E7%99%BD%E5%90%8D%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";
    },

    searchBtn() {
      this.updateDataTag = !this.updateDataTag;
    },
    //重置查询
    resetSearch() {
      this.queryFormData = {
        platform: "",
        is_white: "1",
      };
      this.updateDataTag = !this.updateDataTag;
    },

    // 获取表格数据
    dataQueryFunc() {
      let paramObj = this.queryFormData;
      //   paramObj.user_id = this.$store.state.userId;
      paramObj.customer_id = this.contractProp.customer_id; //客户id

      return {
        apiName: "getCustomWhiteList",
        paramObj,
        success: function(response, callBack) {
          this.dataList = response.data.data.list.map((item) => {
            return {
              ...item,
              editable: false,
            };
          });
          this.totalCount = response.data.data.count;

          // 回调函数
          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function(error, callBack) {
          // 回调函数
          if (callBack) {
            callBack();
          }
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.import_area {
  display: inline-block;
  margin: 0 10px;
  position: relative;

  .import_file {
    position: absolute;
    left: 0;
    width: 80px;
    height: 28px;
    opacity: 0;
  }
}
</style>
